import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ClientSidePanelContextType {
  isOpen: boolean;
  togglePanel: () => void;
  openPanel: () => void;
  closePanel: () => void;
  onPrescriptionSaved?: () => void;
  setOnPrescriptionSaved: (callback: (() => void) | undefined) => void;
  editingPrescription: any | null;
  setEditingPrescription: (prescription: any | null) => void;
}

const ClientSidePanelContext = createContext<ClientSidePanelContextType | undefined>(undefined);

interface ClientSidePanelProviderProps {
  children: ReactNode;
}

export const ClientSidePanelProvider: React.FC<ClientSidePanelProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [onPrescriptionSaved, setOnPrescriptionSaved] = useState<(() => void) | undefined>(undefined);
  const [editingPrescription, setEditingPrescription] = useState<any | null>(null);

  const togglePanel = () => setIsOpen(prev => !prev);
  const openPanel = () => setIsOpen(true);
  const closePanel = () => {
    setIsOpen(false);
    setEditingPrescription(null); // Clear editing prescription when closing
  };

  return (
    <ClientSidePanelContext.Provider value={{
      isOpen,
      togglePanel,
      openPanel,
      closePanel,
      onPrescriptionSaved,
      setOnPrescriptionSaved,
      editingPrescription,
      setEditingPrescription
    }}>
      {children}
    </ClientSidePanelContext.Provider>
  );
};

export const useClientSidePanel = (): ClientSidePanelContextType => {
  const context = useContext(ClientSidePanelContext);
  if (!context) {
    throw new Error('useClientSidePanel must be used within ClientSidePanelProvider');
  }
  return context;
};
